import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  MsalGuardConfiguration,
  MsalService,
  MSAL_GUARD_CONFIG,
} from '@azure/msal-angular';
import {
  AuthenticationResult,
  InteractionType,
  PopupRequest,
  RedirectRequest,
} from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { ThemeService } from '../../services/theme.service';
import { UserService } from '../../services/user.service';

const request = {
  scopes: ['user.read'],
  loginHint: localStorage.getItem('username') || undefined,
  extraQueryParameters: { domain_hint: 'gildedco.com' },
};

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  @Input() loginDisplay: boolean | undefined;

  activePage!: string;
  user: any;
  region: string = '';

  isImageFound: boolean = false;
  userImage: any;

  isSuperAdmin: boolean = false;
  isAdmin: boolean = false;
  isViewer: boolean = false;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private router: Router,
    private userService: UserService,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {
    this.setActivePage(window.location.href);
  }

  ngOnChanges() {
    if (this.loginDisplay) {
      this.getUserImageFromGraph();
      this.user = JSON.parse(localStorage.getItem('user') || '{}');
      if (this.user != null && this.user.idTokenClaims != undefined) {
        let groups: string[] = this.user.idTokenClaims['groups'] as string[];
        if (groups.includes(environment.viewerGroupID)) {
          this.isViewer = true;
        }
        if (groups.includes(environment.adminGroupID)) {
          this.isAdmin = true;
        }
        if (groups.includes(environment.superAdminGroupID)) {
          this.isSuperAdmin = true;
        }
      }
      this.region = localStorage.getItem('region') || '';
    }
    let region = localStorage.getItem('region');
    region = region?.replace(' ', '') || '';
    this.themeService.setTheme(region);
  }

  navigateTo(url: string) {
    this.router.navigateByUrl(url);
    this.setActivePage(url);
  }

  setActivePage(url: string) {
    if (url.includes('create')) {
      this.activePage = 'CREATE USERS';
    } else if (url.includes('lookup')) {
      this.activePage = 'LOOKUP USERS';
    } else if (url.includes('update')) {
      this.activePage = 'UPDATE USERS';
    } else if (url.includes('delete')) {
      this.activePage = 'DELETE USERS';
    } else if (url.includes('restore')) {
      this.activePage = 'RESTORE USERS';
    } else if (url.includes('settings')) {
      this.activePage = 'SETTINGS';
    } else {
      this.activePage = 'HOME';
    }
  }

  login() {
    this.authService.ssoSilent(request).subscribe(
      (data) => {
        if (data.account != null) {
          localStorage.setItem('username', data.account.username);
        }
      },
      (error) => {
        if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
          if (this.msalGuardConfig.authRequest) {
            this.authService
              .loginPopup({
                ...this.msalGuardConfig.authRequest,
              } as PopupRequest)
              .subscribe((response: AuthenticationResult) => {
                this.authService.instance.setActiveAccount(response.account);
              });
          } else {
            this.authService
              .loginPopup()
              .subscribe((response: AuthenticationResult) => {
                this.authService.instance.setActiveAccount(response.account);
              });
          }
        } else {
          if (this.msalGuardConfig.authRequest) {
            this.authService.loginRedirect({
              ...this.msalGuardConfig.authRequest,
            } as RedirectRequest);
          } else {
            this.authService.loginRedirect();
          }
        }
      }
    );
  }

  getUserImageFromGraph() {
    this.userService.getUserImage().subscribe(
      (data) => {
        this.createImageFromBlob(data);
        this.isImageFound = true;
      },
      (error) => {
        this.isImageFound = false;
        console.log(error);
      }
    );
  }

  createImageFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        this.userImage = reader.result;
      },
      false
    );

    if (image) {
      reader.readAsDataURL(image);
    }
  }
}
